import type {ReactElement} from 'react';
import {Text} from '@Components/text';
import {NewFeatureBadge} from '../new-feature-badge/new-feature-badge';
import type {PromoCarouselSlideProps} from './promo-carousel-slide.types';
import styles from './promo-carousel-slide.module.scss';

/** One promo of the login page's left panel: badge, a two-line heading and the artwork, stacked on its siblings. */
export function PromoCarouselSlide({content, isActive, shouldRequestImage, onImageSettled}: PromoCarouselSlideProps): ReactElement {
  const getSlideClasses = (): string => {
    return isActive ? `${styles.slide} ${styles.activeSlide}` : styles.slide;
  };

  const getImageClasses = (): string => {
    return content.isImageWidthCapped ? `${styles.artwork} ${styles.cappedArtwork}` : styles.artwork;
  };

  /** Only the first slide's artwork loads with the page; the rest are requested once it has painted. */
  const getArtwork = (): ReactElement | null => {
    if (!shouldRequestImage) {
      return null;
    }
    return <img alt="" className={getImageClasses()} onError={onImageSettled} onLoad={onImageSettled} src={content.imageUrl} />;
  };

  return (
    <div aria-hidden={!isActive} className={getSlideClasses()}>
      <div className={styles.headingGroup}>
        <NewFeatureBadge />
        <Text val={window.i18next.t(content.headingFirstLineLangKey)} className={`${styles.heading} ${styles.headingFirstLine}`} />
        <Text val={window.i18next.t(content.headingSecondLineLangKey)} className={styles.heading} />
      </div>
      {getArtwork()}
    </div>
  );
}
